import abstractModel from '../../core/MercatelyModel';

const resource = '/api/mia/chatbot/agents';

const model = abstractModel(resource);

model.getIntentionTemplates = (agent, params = {}) => {
  const newResource = `${resource}/${agent.id}/intentions/templates`;
  return model.get(params, { path: newResource });
};

model.getIntentionTemplate = (agent, templateKey, params = {}) => {
  const newResource = `${resource}/${agent.id}/intentions/templates/${templateKey}`;
  return model.get(params, { path: newResource });
};

model.getIntentionsWithSteps = (agent, params = {}) => {
  const newResource = `${resource}/${agent.id}/intentions/with_steps`;
  return model.get(params, { path: newResource });
};

model.createIntentionBranch = (agent, intentionId, data) => {
  const newResource = `${resource}/${agent.id}/intentions/${intentionId}/branches`;
  return model.save(data, { path: newResource });
};

model.updateIntentionBranch = (agent, intentionId, branchId, data) => {
  const newResource = `${resource}/${agent.id}/intentions/${intentionId}/branches`;
  return model.patch({ id: branchId, ...data }, { path: newResource });
};

model.saveIntention = (agent, intentionData) => {
  const newResource = `${resource}/${agent.id}/intentions`;
  return model.save(intentionData, { path: newResource });
};

model.deleteIntention = (agent, intentionId) => {
  const newResource = `${resource}/${agent.id}/intentions/${intentionId}`;
  return model.remove({}, { path: newResource });
};

model.getGlobalInstructions = (agent, params = {}) => {
  const newResource = `${resource}/${agent.id}/guidelines`;
  return model.get(params, { path: newResource });
};

model.saveGlobalInstruction = (agent, instructionData) => {
  const newResource = `${resource}/${agent.id}/guidelines`;
  const { id, ...guidelineFields } = instructionData;
  const body = { guideline: guidelineFields };
  if (id) body.id = id;
  return model.save(body, { path: newResource });
};

model.deleteGlobalInstruction = (agent, instructionId) => {
  const newResource = `${resource}/${agent.id}/guidelines/${instructionId}`;
  return model.remove({}, { path: newResource });
};

model.getInitialSteps = (agent, params = {}) => {
  const newResource = `${resource}/${agent.id}/initial_steps`;
  return model.get(params, { path: newResource });
};

model.saveInitialStep = (agent, stepData) => {
  const newResource = `${resource}/${agent.id}/initial_steps`;
  const { id, ...initialStepFields } = stepData;
  const body = { initial_step: initialStepFields };
  if (id) body.id = id;
  return model.save(body, { path: newResource });
};

model.deleteInitialStep = (agent, stepId) => {
  const newResource = `${resource}/${agent.id}/initial_steps`;
  return model.remove({ id: stepId }, { path: newResource });
};

model.saveIntentionStep = (agent, intentionId, stepData) => {
  const newResource = `${resource}/${agent.id}/intentions/${intentionId}/steps`;
  const { id, ...stepFields } = stepData;
  const body = { step: stepFields };
  if (id) body.id = id;
  return model.save(body, { path: newResource });
};

model.deleteIntentionStep = (agent, intentionId, stepId) => {
  const newResource = `${resource}/${agent.id}/intentions/${intentionId}/steps/${stepId}`;
  return model.remove({}, { path: newResource });
};

model.moveUpIntentionStep = (agent, intentionId, stepId) => {
  const newResource = `${resource}/${agent.id}/intentions/${intentionId}/steps/${stepId}/move_up`;
  return model.patch({}, { path: newResource });
};

model.moveDownIntentionStep = (agent, intentionId, stepId) => {
  const newResource = `${resource}/${agent.id}/intentions/${intentionId}/steps/${stepId}/move_down`;
  return model.patch({}, { path: newResource });
};

export default model;
